"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErxModule = void 0;
const api_1 = require("client/api");
const tabs_1 = require("client/components/material/tabs");
const form_1 = require("client/components/ui/form");
const select_1 = require("client/components/ui/select");
const text_field_1 = require("client/components/ui/text-field");
const store_1 = require("client/modules/inventory/modules/inventory-create/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./erx.less");
const logger_1 = require("shared/logger");
const log = new logger_1.Logger("client/erx");
const genderOptions = [
    {
        id: 1,
        label: "Male",
        value: "1"
    },
    {
        id: 2,
        label: "Female",
        value: "2"
    }
];
let ErxModule = class ErxModule extends react_1.Component {
    constructor() {
        super(...arguments);
        this.claim = {};
        this.claimReversal = {};
        this.eligibility = {};
        this.tab = 0;
        this.fields = {
            firstName: "David",
            lastName: "Quattlebaum",
            cardholderId: "",
            ndc: "00002-1407",
            zipCode: "29630",
            gender: "1",
            birthDate: "19690314",
            address: "111 Sourwood St",
            address2: "",
            city: "Central",
            state: "SC"
        };
        this.handleTab = (event, tab) => {
            this.tab = tab;
        };
        this.handleChange = (fieldName) => (event, value) => {
            this.fields[fieldName] = value;
        };
        this.handleSelect = (fieldName) => (value) => {
            this.fields[fieldName] = value;
        };
        this.handleSearch = (value) => {
            store_1.inventoryCreateStore.loadNDCs(value);
        };
        this.handleSubmitClaim = async () => {
            this.claim = { loading: true };
            const response = await api_1.SinkEndpoint.claim.apiCall(null, {
                ndc: this.fields.ndc.replace(/\-/g, "")
            });
            if (api_1.isError(response)) {
                this.claim = { error: response.code };
            }
            else {
                this.claim = {};
                alert(JSON.stringify(response.response, null, 2));
            }
        };
        this.handleSubmitClaimReversal = async () => {
            this.claimReversal = { loading: true };
            const response = await api_1.SinkEndpoint.claimReversal.apiCall(null, {
                ndc: this.fields.ndc.replace(/\-/g, "")
            });
            if (api_1.isError(response)) {
                this.claimReversal = { error: response.code };
            }
            else {
                this.claimReversal = {};
                alert(JSON.stringify(response.response, null, 2));
            }
        };
        this.handleSubmitEligibility = async () => {
            this.eligibility = { loading: true };
            const response = await api_1.SinkEndpoint.eligibility.apiCall(null, {
                firstName: this.fields.firstName,
                lastName: this.fields.lastName,
                cardholderId: this.fields.cardholderId,
                zipCode: this.fields.zipCode,
                gender: this.fields.gender,
                birthDate: this.fields.birthDate,
                insuranceRelationship: "1",
                address: this.fields.address,
                city: this.fields.city,
                state: this.fields.state
            });
            if (api_1.isError(response)) {
                this.eligibility = { error: response.code };
            }
            else {
                this.eligibility = {};
                log.debug(JSON.stringify(response.response, null, 2));
            }
        };
    }
    get availableOptions() {
        return store_1.inventoryCreateStore.ndcs.value
            ? store_1.inventoryCreateStore.ndcs.value.map((ndc, i) => ({
                id: i,
                label: ndc.ndc,
                value: ndc.ndc
            }))
            : [];
    }
    render() {
        return (React.createElement("div", { className: "erx" },
            React.createElement(tabs_1.MaterialTabs, { tabs: [
                    { label: "Claim" },
                    { label: "Claim Reversal" },
                    { label: "Eligibility" }
                ], onChange: this.handleTab, value: this.tab }),
            this.tab === 0 && (React.createElement(form_1.UiForm, { onSubmit: this.handleSubmitClaim, buttons: ["submit"], error: this.claim.error, loading: this.claim.loading },
                React.createElement("div", { className: "row" },
                    React.createElement(text_field_1.UiTextField, { label: "NDC", value: this.fields.ndc, onChange: this.handleChange("ndc") }),
                    React.createElement(select_1.UiSelect, { label: "NDC", options: this.availableOptions, value: this.fields.ndc, onSearch: this.handleSearch, onSelect: this.handleSelect("ndc") })))),
            this.tab === 1 && (React.createElement(form_1.UiForm, { onSubmit: this.handleSubmitClaimReversal, buttons: ["submit"], error: this.claimReversal.error, loading: this.claimReversal.loading },
                React.createElement("div", { className: "row" },
                    React.createElement(text_field_1.UiTextField, { label: "NDC", value: this.fields.ndc, onChange: this.handleChange("ndc") }),
                    React.createElement(select_1.UiSelect, { label: "NDC", options: this.availableOptions, value: this.fields.ndc, onSearch: this.handleSearch, onSelect: this.handleSelect("ndc") })))),
            this.tab === 2 && (React.createElement(form_1.UiForm, { onSubmit: this.handleSubmitEligibility, buttons: ["submit"], error: this.eligibility.error, loading: this.eligibility.loading },
                React.createElement("div", { className: "row" },
                    React.createElement(text_field_1.UiTextField, { label: "first name", value: this.fields.firstName, onChange: this.handleChange("firstName") }),
                    React.createElement(text_field_1.UiTextField, { label: "last name", value: this.fields.lastName, onChange: this.handleChange("lastName") })),
                React.createElement("div", { className: "row" },
                    React.createElement(text_field_1.UiTextField, { label: "cardholder id", value: this.fields.cardholderId, onChange: this.handleChange("cardholderId") }),
                    React.createElement(text_field_1.UiTextField, { label: "zip code", value: this.fields.zipCode, onChange: this.handleChange("zipCode") })),
                React.createElement("div", { className: "row" },
                    React.createElement(select_1.UiSelect, { label: "gender", options: genderOptions, value: this.fields.gender, onSelect: this.handleSelect("gender") }),
                    React.createElement(text_field_1.UiTextField, { label: "birth date (YYYYMMDD)", value: this.fields.birthDate, onChange: this.handleChange("birthDate") })),
                React.createElement("div", { className: "row" },
                    React.createElement(text_field_1.UiTextField, { label: "address", value: this.fields.address, onChange: this.handleChange("address") }),
                    React.createElement(text_field_1.UiTextField, { label: "city", value: this.fields.city, onChange: this.handleChange("city") })),
                React.createElement("div", { className: "row" },
                    React.createElement(text_field_1.UiTextField, { label: "state", value: this.fields.state, onChange: this.handleChange("state") }))))));
    }
};
__decorate([
    mobx_1.computed
], ErxModule.prototype, "availableOptions", null);
__decorate([
    mobx_1.observable
], ErxModule.prototype, "claim", void 0);
__decorate([
    mobx_1.observable
], ErxModule.prototype, "claimReversal", void 0);
__decorate([
    mobx_1.observable
], ErxModule.prototype, "eligibility", void 0);
__decorate([
    mobx_1.observable
], ErxModule.prototype, "tab", void 0);
__decorate([
    mobx_1.observable
], ErxModule.prototype, "fields", void 0);
ErxModule = __decorate([
    mobx_react_1.observer
], ErxModule);
exports.ErxModule = ErxModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/erx/erx.tsx
// module id = 3442
// module chunks = 0